import { Injectable } from "@angular/core";
import { StateService } from "@core-services/state.service";
import { Observable } from "rxjs";
import { NewAccount } from "../entities/new_account.model";
import { Term } from "@models/term";

const initialState: NewAccount | null = null;

@Injectable({
	providedIn: "root"
})
export class NewAccountStateService extends StateService<NewAccount> {
	constructor() {
		super(initialState);
	}

	public getAccount$(): Observable<NewAccount> {
		return this.select((state) => state);
	}

	public updateAccount(account: NewAccount): void {
		this.setState(account);
	}

	public isAccountLoaded(): boolean {
		return !!this.state;
	}

	public acceptBest2Terms(): void {
		// TODO_NEW Change for object when possible
		const best2Term: Term = new Term();
		best2Term.setType("best2_terms");
		best2Term.setSigned(true);

		this.updateAccount({ ...this.state, terms: [...this.state.terms, best2Term], is_best2_terms_accepted: true });
	}
}
